<template>
  <MainLayout>
		<div class="container">
			<div class="box">
        <!-- Create a new Rule -->
        <b-dropdown
         variant="primary"
          text="Nueva regla de canal" 
          class="m-md-2 float-right" 
          v-if="$hasPermission('salesChannelRules.add')">
          <b-dropdown-item @click="newModel('buffer_time')">Buffer Time</b-dropdown-item>
          <b-dropdown-item @click="newModel('cutoff')">Cutoff Time</b-dropdown-item>
          <b-dropdown-item @click="newModel('genius_booking')">Genius Booking</b-dropdown-item>
        </b-dropdown>

				<h2>Reglas de canal de venta</h2>
        <hr/>

        <!-- filters options -->
        <b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'sales-channel-rules-index-list') } ">
          <div class="row pb-3">
            <b-form-group class="col-3" label="Nombre">
              <b-form-input v-model="filters.search" type="text" />
            </b-form-group>

            <b-form-group
              class="col-lg-4"
              label="Canal de venta">
              <multiselect
                  :options="salesChannelsOpts"
                  v-model="filters.salesChannel"
                  :multiple="false"
                  :show-labels="false"
                  label="name"
                  track-by="id">
                  <template v-slot:clear >
                    <div class="multiselect__clear" @click="filters.salesChannel = ''"></div>
                  </template>
              </multiselect>
            </b-form-group>

            <b-form-group
                class="col-lg-4"
                label="Destino">
                <multiselect
                  :options="destinationsOpts"
                  v-model="filters.destination"
                  :multiple="false"
                  :show-labels="false"
                  label="name"
                  track-by="id">
                    <template v-slot:clear >
                      <div class="multiselect__clear" @click="filters.destination = ''"></div>
                    </template>
                </multiselect>
            </b-form-group>

            <b-form-group
              class="col-lg-3"
              label="Tipo de regla">
              <multiselect
                :options="ruleTypeOpts"
                v-model="filters.ruleType"
                :multiple="false"
                :show-labels="false"
                label="name"
                track-by="id">
                  <template v-slot:clear >
                    <div class="multiselect__clear" @click="filters.ruleType = ''"></div>
                  </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              class="col-lg-4 mt-2"
              label=".">
              <b-form-checkbox
                :value="true"
                v-model="filters.noSaleChannel"
              >
            Mostrar reglas sin canal de venta
          </b-form-checkbox>
            </b-form-group>

            <b-form-group class="col-2" label=".">
                <b-button type="submit" variant="primary">Buscar</b-button>
            </b-form-group>
          </div>
        </b-form>

        <AjaxTable
					permission-show="salesChannelRules.show"
					id="sales-channel-rules-index-list"
					:columns="modelColumns"
          :filters="filters" 
					resource="sales-channel-rules"
				>

          <template v-slot:cell(salesChannel)="row">
            <div v-if="row.item.salesChannel != null">
              {{ row.item.salesChannel.name }}
            </div>
            <div v-else>
              Sin canal de venta
            </div>
          </template>

          <template v-slot:cell(ruleType)="row">
            <div class="text-center">
              <b-badge variant="info" v-if="row.item.ruleType == 'buffer_time'">
                  Buffer Time
              </b-badge>
              <b-badge variant="info" v-if="row.item.ruleType == 'cutoff'">
                  Cutoff
              </b-badge>
              <b-badge variant="info" v-if="row.item.ruleType == 'genius_booking'">
                  Genius Booking
              </b-badge>
            </div>
          </template>

          <template v-slot:cell(zones)="row">
            <div class="">
              <label v-for="(zone, index) in row.item.zones" :key="index">{{ zone.name }}</label>
            </div>
          </template>

          <template v-slot:cell(settings)="row">
            <div class="text-center">
                <b-badge variant="primary">
                  Settings <b-badge variant="light">{{ row.item.settings.length }}</b-badge>
                </b-badge>
            </div>
          </template>
          
          <template v-slot:cell(status)="row">
            <div class="text-center">
              <b-badge variant="success" v-if="row.item.status == 'active'">
                Activo
              </b-badge>
              <b-badge variant="warning" v-if="row.item.status == 'inactive'">
                Inactivo
              </b-badge>
            </div>
          </template>

					<template v-slot:cell(actions)="row">
						<div class="text-center">
              <b-button
                  v-if="$hasPermission('salesChannelRules.edit')" 
                  @click="(event) => editModel(row.item.id)" 
                  type="button" size="sm" class="mr-1" variant="info">
                  <md-icon icon="edit" />
              </b-button>

              <b-button v-if="$hasPermission('salesChannelRules.delete')" 
                @click="(event) => modelDelete(row.item,row.index,event)" 
                type="button" size="sm" class="mr-1" variant="danger">
                  <md-icon icon="delete" />
              </b-button>
						</div>
					</template>
				</AjaxTable>
      </div>
    </div>

    <Single :unableEdit.sync="unableEdit" ref="single" :success-callback="successCallback" :item="salesChannel"/>

  </MainLayout>
</template>

<script>
  
  import MainLayout from "../layout/MainLayout.vue";
  import AjaxTable from "../../helpers/AjaxTable.vue";
  import Multiselect from "vue-multiselect";
  import Single from "./Single.vue";
  import api from "../../../api.js";

  export default {
    components: { MainLayout, Single, AjaxTable, Multiselect},
    data() {
      return {
        modelId: -1,
        unableEdit: false,
        salesChannel: null,
        modalInfo: {
          modelId: -1,
          title: "Regla"
        },
        filters: {
          search: "",
          salesChannel: '',
          destination: '',
          ruleType: '',
          noSaleChannel: false
        },
        modelColumns: [
          { key: "id",           label: "ID" },
          { key: "name",         label: "Nombre" },
          { key: "salesChannel", label: "Canal" },
          { key: "zones",        label: "Destinos" },
          { key: "ruleType",     label: "Tipo de regla" },
          { key: "settings",     label: "Settings" },
          { key: "status",       label: "Estado" },
          { key: "actions",      label: "Acciones" }
        ],
        salesChannelsOpts: [],
        destinationsOpts: [],
        ruleTypeOpts: [
          {id: 'buffer_time', name: 'Buffer Time'},
          {id: 'cutoff', name: 'Cutoff'},
          {id: 'genius_booking', name: 'Genius Booking'}
        ]
      }
    },
    methods: {
      successCallback(){
				this.$root.$emit('bv::refresh::table', 'sales-channel-rules-index-list')
			},
			editModel(id) {
				this.$refs['single'].loadModel(id)
			},
      newModel(ruleType) {
        this.$refs['single'].loadModel(-1, ruleType)
      },
      modelDelete(item) {              
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
            api(this).delete(`/sales-channel-rules/${item.id}`).then((response) => {
							if (response.data.error) {
								this.$root.showAlert(response.data.message, {variant: 'warning'})
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
							this.$root.$emit('bv::refresh::table', 'sales-channel-rules-index-list')
							close()
						}).catch(err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			},
      getSalesChannelsOpts() {
        this.$root.api.get('/sales-channels?limit=2000')
          .then(res => {
              this.salesChannelsOpts = res.data.rows.map(zn => ({id: zn.id, name: zn.name}))
          })
          .catch(this.$root.handleRequestError)
          .then(() => {
              this.loading = false;
          });
      },
      getDestinationsOpts() {
        this.$root.api.get('/zoned-areas/master?withZones=true')
          .then(res => {
              this.destinationsOpts = res.data
          })
          .catch(this.$root.handleRequestError)
          .then(() => {
              this.loading = false;
          });
      },
    },
    mounted() {
      this.getSalesChannelsOpts()
      this.getDestinationsOpts()
    },
  }
</script>